var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBell = function SvgBell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12337 1.78256L4.54564 0.169231C1.89769 2.23385 0.154463 5.41538 0 9.02564H2.20662C2.37212 6.0359 3.87262 3.41846 6.12337 1.78256ZM19.7934 9.02564H22C21.8345 5.41538 20.0913 2.23385 17.4544 0.169231L15.8877 1.78256C18.1164 3.41846 19.6279 6.0359 19.7934 9.02564ZM17.6199 9.58974C17.6199 6.12615 15.8104 3.22667 12.655 2.45949V1.69231C12.655 0.755897 11.9157 0 11 0C10.0843 0 9.34504 0.755897 9.34504 1.69231V2.45949C6.17854 3.22667 4.38014 6.11487 4.38014 9.58974V15.2308L2.17352 17.4872V18.6154H19.8265V17.4872L17.6199 15.2308V9.58974ZM11 22C11.1545 22 11.2979 21.9887 11.4413 21.9549C12.1585 21.7969 12.7432 21.3005 13.0301 20.6236C13.1404 20.3528 13.1956 20.0595 13.1956 19.7436H8.78235C8.79338 20.9846 9.77533 22 11 22Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export default ForwardRef;